export default {"src":"/_next/static/media/codex-icon.bbbc5c64.svg","height":835,"width":1008};